import { Database, Tables } from "@/supabase/types"
import { PermContentType } from "./content-type"

export enum PermAction {
	drag = "drag",
  edit = "edit",
  view = "view",
  select = "select",
  delete = "delete",
  create = "create",
  update = "update",
  save = "save"
}

export type AnyPermAction =
	PermAction
 | 'ALL'

export interface PermOptions {
  type: PermContentType
  action: PermAction
  context?: string
  uuid?: string
  relUuid?: string
	ws?: Tables<'workspaces'> | null
  ws_id?: string
  user_id?: string
  tenant?: string | null
  skipCache?: boolean
}

//for evaluate permissions
export interface BatchPermOptions extends Omit<PermOptions, 'action'> {}

export type Permissions = Record<string, boolean>

export const permOptionsKey = (options: PermOptions): string => {
	const userId = options.user_id || options.ws?.user_id || ''
	const wsId = options.ws_id || options.ws?.id || ''
  return [
    options.type,
    options.action,
    options.context || '',
    options.uuid || '',
    options.relUuid || '',
    wsId,
		userId,
    options.tenant || ''
  ].join('|')
}

export const permOptionsFromKey = (key: string): PermOptions => {
  const [type, action, context, uuid, relUuid, wsId, user_id, tenant] = key.split('|')
  return {
    type: type as PermContentType,
    action: action as PermAction,
    context: context || undefined,
    uuid: uuid || undefined,
    relUuid: relUuid || undefined,
    ws_id: wsId || undefined,
    user_id: user_id || undefined,
    tenant: tenant || undefined,
  }
}

export type WithPermissions<T> = T & { permissions: Permissions }

export type TableWithPermissions<T extends keyof Database['public']['Tables']> = WithPermissions<Tables<T>>
